<div [formGroup]="form">
    <mat-checkbox [formControlName]="item.name" (change)="onChange($event)" [required]="item.required">{{item.label}}</mat-checkbox>
</div>